import gql from 'graphql-tag'

export default gql`mutation phxFacilityAddOpenEnrollment($facility_ids: [ID]!) {
	phxFacilityAddOpenEnrollment(facility_ids: $facility_ids) {
		status
  }
}`
